import React from 'react';
import Moment from 'react-moment';
import { useTranslation } from 'react-i18next';
import {
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from '@/components/ui/card';
import { Heading } from '@/components/ui/shared/heading';

export const VisitServiceDetails = ({ visitDetails }) => {
  const { t } = useTranslation();

  function calculateRemainingPaymentPrice(service) {
    if (
      Array.isArray(service.payments) &&
      service.payments.some((x) => x.paymentType !== null)
    ) {
      let price = service.price;
      service.payments.forEach((payment) => {
        if (payment.paymentType != null) {
          price -= payment.price;
        }
      });
      return price > 0 ? price.toFixed(2) : null;
    }
  }

  return (
    <div className="space-y-4">
      {/* Shared visit info card */}
      <Card>
        <CardHeader>
          <Heading variant="userAccountDetailsTitle">
            {t('userAccount.visitTab.visitInfo')}
          </Heading>
        </CardHeader>
        <CardContent className="space-y-2">
          <div>
            <span>{t('userAccount.visitTab.medicalCenter')} </span>
            <span>
              {visitDetails.department} {visitDetails.departmentAddress}
            </span>
          </div>

          <div>
            <span>{t('userAccount.visitTab.date')}</span>
            <span>
              {new Date(Date.parse(visitDetails.date)).getUTCHours() === 0 ? (
                <Moment utc format="YYYY-MM-DD">
                  {visitDetails.date}
                </Moment>
              ) : (
                <Moment utc format="YYYY-MM-DD HH:mm">
                  {visitDetails.date}
                </Moment>
              )}
            </span>
          </div>
        </CardContent>
        <CardFooter />
      </Card>

      {/* Cards for each service */}
      {Array.isArray(visitDetails.services) &&
        visitDetails.services.map((service, index) => (
          <Card key={index}>
            <CardHeader>
              <Heading variant="userAccountDetailsTitle">
                {service.name}
              </Heading>
            </CardHeader>
            <CardContent className="space-y-2">
              {Array.isArray(service.payments) &&
                service.payments.some(
                  (x) => x.paymentType !== 'VLK (PSDF)',
                ) && (
                  <div>
                    <span>{t('userAccount.visitTab.price')} </span>
                    <span>{service.price.toFixed(2)}</span>
                  </div>
                )}

              {Array.isArray(service.payments) &&
                service.payments.some(
                  (x) =>
                    x.paymentType?.toLowerCase() !== 'draudimas' &&
                    x.paymentType !== 'VLK (PSDF)',
                ) &&
                service.status && (
                  <div>
                    <span>{t('userAccount.visitTab.state')} </span>
                    <span>
                      {service.status} {calculateRemainingPaymentPrice(service)}
                    </span>
                  </div>
                )}

              {Array.isArray(service.payments) &&
                service.payments.some((x) => x.paymentType !== null) && (
                  <span>
                    <span>{t('userAccount.visitTab.paymentType')} </span>
                  </span>
                )}

              {Array.isArray(service.payments) &&
                service.payments
                  .filter((x) => x.paymentType !== null)
                  .map((payment, i) => (
                    <span key={i}>
                      <span>{payment.paymentType}</span>
                      {payment.paymentType !== 'VLK (PSDF)' && (
                        <span> - {payment.price.toFixed(2)} </span>
                      )}
                    </span>
                  ))}
            </CardContent>
            <CardFooter />
          </Card>
        ))}
    </div>
  );
};
